var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectName({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37695 13.0605C1.37695 9.28955 1.37695 7.40355 2.54895 6.23255C3.72095 5.06155 5.60595 5.06055 9.37695 5.06055H13.377C17.148 5.06055 19.034 5.06055 20.205 6.23255C20.859 6.88555 21.148 7.76055 21.275 9.06055M21.377 13.0605C21.377 16.8315 21.377 18.7175 20.205 19.8885C19.033 21.0595 17.148 21.0605 13.377 21.0605H9.37695C5.60595 21.0605 3.71995 21.0605 2.54895 19.8885C1.89495 19.2355 1.60595 18.3605 1.47895 17.0605",
    stroke: "#F16806",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.377 5.06055C15.377 3.17455 15.377 2.23255 14.791 1.64655C14.205 1.06055 13.263 1.06055 11.377 1.06055C9.49095 1.06055 8.54895 1.06055 7.96295 1.64655C7.37695 2.23255 7.37695 3.17455 7.37695 5.06055",
    stroke: "#F16806"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.877 13.0605H9.87695M11.377 11.5605V14.5605",
    stroke: "#F16806",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.377 17.0605C13.5861 17.0605 15.377 15.2697 15.377 13.0605C15.377 10.8514 13.5861 9.06055 11.377 9.06055C9.16781 9.06055 7.37695 10.8514 7.37695 13.0605C7.37695 15.2697 9.16781 17.0605 11.377 17.0605Z",
    stroke: "#F16806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectName);
export default __webpack_public_path__ + "static/media/project-name.3a02c3cdd7c6c22b6621648e302211ad.svg";
export { ForwardRef as ReactComponent };